import { Divider } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import { scrollToTop } from "apps/commons/functions/scrollToTop";
import { descriptionBinder } from "libs/analytics/binders/onboarding/description";
import { useAnalytics } from "libs/analytics/useAnalytics";
import { useEffect } from "react";
import { Title } from "../Title";
import { DetailsPage } from "../details/Page";
import { useMetadataAtomValue } from "../metadataAtom";
import { useStaticDataAtomValue } from "../staticDataAtom";
import { PropertyDescriptionController } from "./PropertyDescriptionController";
import { PropertyNameController } from "./PropertyNameController";

export const DescriptionPage = () => {
    const {
        cmsData: {
            description: { description },
        },
    } = useStaticDataAtomValue();

    const {
        experimentsAtom: { isConvergencePropertyDetails },
    } = useMetadataAtomValue();

    useEffect(() => {
        scrollToTop();
    }, []);

    useAnalytics(descriptionBinder);

    if (isConvergencePropertyDetails) {
        return <DetailsPage />;
    }

    return (
        <VStack gap="24" pb="32">
            <Title title={description} />
            <PropertyNameController />
            <Divider />
            <PropertyDescriptionController />
        </VStack>
    );
};
